import React, { useMemo } from 'react';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import styled from "styled-components";
import Colours from '@shared/ui/atoms/Colours';
import { removeVisitor } from "../../models/meeting-room-booking-dialog.duck";
import { useDispatch } from "react-redux";
import { VisitorBooking } from "../../../../components/pages/company-movements/components/visitor-booking/data/visitor-booking-service";

export function VisitorAttendeeRow(props: Props) {
  const dispatch = useDispatch();
  const {visitor} = props;

  const firstInitial = useMemo(() => {
    if (visitor.visitorName) {
      const split = visitor.visitorName.split(' ');
      if (split.length > 0 && split[0].length > 0) {
        return split[0][0];
      }
    }
    return '';
  }, [visitor.visitorName]);

  const lastInitial = useMemo(() => {
    if (visitor.visitorName) {
      const split = visitor.visitorName.split(' ');
      if (split.length > 0 && split[split.length - 1].length > 0) {
        return split[split.length - 1][0];
      }
    }
    return '';
  }, [visitor.visitorName]);

  const onRemoveVisitorClicked = (visitor: VisitorBooking) => {
    if (props.userCanSaveBooking) {
      dispatch(removeVisitor(visitor));
    }
  }

  return (<UserInfoRow>
    <UserAvatarAndName colour={'green'}
                       firstName={firstInitial}
                       lastName={lastInitial}
                       fullName={visitor.visitorName}
                       jobTitle={visitor.companyName}
                       email={visitor.email}
                       style={{width: '100%'}} />
    <IconButton disabled={!props.userCanSaveBooking}
                icon={IconTypes.Bin}
                onClick={() => onRemoveVisitorClicked(visitor)} />
  </UserInfoRow>)
}

interface Props {
  userCanSaveBooking: boolean;
  visitor: VisitorBooking;
}

export const UserInfoRow = styled.div<any>`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${Colours.veryLightGrey};
  padding-bottom: 12px;
  margin-bottom: 12px;
  &:last-child {
    border-bottom: none;
  }
  .userAvatarAndName {
    width: 100%;
  }
`
